"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
const makeGroupBySingleFieldPointerMethod_1 = require("../makeGroupBySingleFieldPointerMethod");
exports.concentrationLimitPointerMethods = [
    (0, makeGroupBySingleFieldPointerMethod_1.makeGroupBySingleFieldPointerMethod)({
        field: 'physical_address_state_or_region',
        method: 'mercuryNatixis1.singleState',
        type: 'string',
        exclusion: {
            largestNumberOfGroups: 3,
        },
    }),
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map